/** Shared UI labels. This module has no React route dependency. */
export const MUSCLE_GROUP_MAP: Record<string, string> = {
  chest: "fitness.muscles.chest", back: "fitness.muscles.back", shoulders: "fitness.muscles.shoulders",
  biceps: "fitness.muscles.biceps", triceps: "fitness.muscles.triceps", legs: "fitness.muscles.legs",
  arms: "fitness.muscles.arms", core: "fitness.muscles.core", glutes: "fitness.muscles.glutes", cardio: "fitness.muscles.cardio",
};
